import * as defaultImport from "@splunk/dashboard-layouts";
export * from "@splunk/dashboard-layouts";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
